// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"99b3821a","958":"99b3821a"}[chunkId] + ".chunk.css";
};